var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2162_2851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8292 13.0044L10.3473 9.52245C11.2961 8.36197 11.7627 6.88117 11.6504 5.38636C11.538 3.89155 10.8555 2.49709 9.74388 1.49142C8.63226 0.485748 7.17663 -0.0541959 5.67807 -0.0167273C4.17952 0.0207412 2.75269 0.632756 1.69272 1.69272C0.632756 2.75269 0.0207412 4.17952 -0.0167273 5.67807C-0.0541959 7.17663 0.485748 8.63226 1.49142 9.74388C2.49709 10.8555 3.89155 11.538 5.38636 11.6504C6.88117 11.7627 8.36197 11.2961 9.52245 10.3473L13.0044 13.8292C13.1144 13.9355 13.2617 13.9943 13.4147 13.9929C13.5676 13.9916 13.7139 13.9303 13.8221 13.8221C13.9303 13.7139 13.9916 13.5676 13.9929 13.4147C13.9943 13.2617 13.9355 13.1144 13.8292 13.0044ZM5.83345 10.5001C4.91047 10.5001 4.00822 10.2264 3.24079 9.71364C2.47336 9.20086 1.87522 8.47203 1.52201 7.61931C1.1688 6.76658 1.07639 5.82827 1.25645 4.92303C1.43652 4.01778 1.88097 3.18626 2.53362 2.53362C3.18626 1.88097 4.01778 1.43652 4.92303 1.25645C5.82827 1.07639 6.76658 1.1688 7.61931 1.52201C8.47203 1.87522 9.20086 2.47336 9.71364 3.24079C10.2264 4.00822 10.5001 4.91047 10.5001 5.83345C10.4987 7.0707 10.0066 8.25688 9.13175 9.13175C8.25688 10.0066 7.0707 10.4987 5.83345 10.5001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2162_2851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.42925d5d0ad848212c25ae2177e75de8.svg";
export { ForwardRef as ReactComponent };